<script setup lang="ts">
import { MetalPlanData } from '@/page/domain/MetalPlanData';
import { useTranslation } from '@hfc/ui-core';

const props = defineProps<{
  plan: MetalPlanData,
}>();

const { t } = useTranslation();

const detailsPlan = [
  {
    label: t('metalPlans.deductible'),
    value: props.plan.deductible
  },
  {
    label: t('metalPlans.doctorVisits'),
    value: props.plan.doctorVisits
  },
  {
    label: t('metalPlans.genericDrugs'),
    value: props.plan.genericDrugs
  },
  {
    label: t('metalPlans.hospital'),
    value: props.plan.hospital
  },
  {
    label: t('metalPlans.oopMax'),
    value: props.plan.oopMax
  }
];
</script>
<template>
  <table>
    <thead>
      <tr v-for="(detail, index) in detailsPlan" :key="index" class="border-b-2 last:border-0">
        <td class="flex min-w-[130px] py-2">{{ detail.label }}</td>
        <td class="py-2" v-html="detail.value"></td>
      </tr>
    </thead>
  </table>
</template>
